import { Box, Button, Row, Title } from '@factorialco/deprecated-design-system'
import { WorkingConditionsListFragment } from 'generated/resources/graphql'
import { useToggle } from 'usehooks-ts'

import i18n from 'modules/core/lib/i18n'

import CreateWorkingConditionModal from './CreateWorkingConditionModal'
import WorkConditionsList from './WorkConditionsList'

type Props = {
  groups: WorkingConditionsListFragment[]
  loading?: boolean
}

const WorkConditions = ({ groups, loading }: Props) => {
  const [showModal, toggleModal] = useToggle(false)

  return (
    <Box flexGrow width="full">
      <Row>
        <Row.Col halfWidth>
          <Box padding="s24" gap="s16">
            <Title
              variant="500"
              illustration="checks"
              title={i18n.t('company_settings.general.employment_data.work_conditions.title')}
              description={i18n.t(
                'company_settings.general.employment_data.work_conditions.description'
              )}
            >
              <Button iconName="add" type="secondary" onClick={toggleModal}>
                {i18n.t('settings.working_condititions.add_button')}
              </Button>
            </Title>
          </Box>
        </Row.Col>
        <Row.Col halfWidth>
          <WorkConditionsList groups={groups} loading={loading} />
        </Row.Col>
      </Row>
      {showModal && <CreateWorkingConditionModal onClose={toggleModal} />}
    </Box>
  )
}

export default WorkConditions
